import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=394716d4"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports